import { z } from "zod";
import { SiteVisitSchema } from "./SiteVisit";
import { SiteSchema } from "./Site";
import { positiveNumber, nonEmptyString, positiveInteger, nonNegativeInteger, nonNegativeNumber, stringToNumber } from "@/utils/form";
import { t } from "i18next";

export const MobileServiceSchema = z.object({
  additional: z.boolean().optional(),
  name: nonEmptyString(t("mobileservice.inputs.name.label")),
  operationalOrganizationId: z.preprocess(
    stringToNumber,
    z.number({
      error: (issue) => issue.input === undefined ?
        t("schemas:form.required")
        :
        t("schemas:form.invalid")
    })
  ),
  hourlyWage: positiveNumber(t("mobileservice.inputs.hourlywage.label")),
  travelTime: positiveInteger(t("mobileservice.inputs.traveltime.label")),
  hoursBriefingPerEmployee: nonNegativeInteger(t("mobileservice.inputs.hoursbriefingperemployee.label")),
  info: z.string().max(500, t("schemas:form.maxlength", { max: 500 })).optional(),
  siteId: z.number().optional(),
  payGroup: z.string(),
  nonTariffAllowance: nonNegativeNumber(t("mobileservice.inputs.nontariffallowance.label")),
  siteInput: SiteSchema.optional(),
  siteVisits: z.array(SiteVisitSchema).min(1, { message: t("schemas:mobileservice.sitevisitsrequired") }),
});

export const MobileServiceDefaultValues = {
  additional: false,
  name: "",
  operationalOrganizationId: undefined,
  hourlyWage: undefined,
  travelTime: undefined,
  siteId: undefined,
  payGroup: "x",
  nonTariffAllowance: 0,
  info: "",
  siteInput: undefined,
  siteVisits: [],
};

export type TMobileServiceSchema = z.infer<typeof MobileServiceSchema>;
